<template>
  <div class="login-wrap">
    <pwd-notice v-if="pwdMsg"></pwd-notice>
    <div class="login-top">
      <login-top />
      <div class="content-part">
        <div class="passWorldTip" >
          <div class="flex">
            <img src="@/assets/img/Rules.png" class="tips-icon">
            <div v-html="$t('login_password_hints')"></div>
          </div>
          <div class="flex my-20">
            <img src="@/assets/img/Note.png" class="tips-icon">
            <div v-html="$t('login_password_note')"></div>
          </div>
        </div>
        <div class="ms-login">
          <div class="ms-title">{{ $t('login_forget')}}</div>
           <p v-if="!forgotFlag" class="font-light">{{$t("login.forgot")}}</p>
           <p v-else class="font-light">{{$t("login.changePassword")}}</p>
        
          <el-tabs v-if="tabsShow &&!forgotFlag" class="cust-tabs" type="border-card" 
             v-model="param.verificationCodeType" @tab-click='handleTabClick'>
              <el-tab-pane v-for="tab in tabs" :key="tab.code" :name="tab.code" :label="tab.name">
                <span slot="label" class="tab-label"><SvgIcon class="way-icon" :icon-name="tab.icon" size="18" :icon-color="param.verificationCodeType===tab.code?'#005eb8':'rgb(38 47 63)'"></SvgIcon> {{$t(tab.name)}}</span>
              </el-tab-pane>
          </el-tabs>
          <el-form :model="param"
                   :rules="rules"
                   ref="login"
                   label-width="0px"
                   class="ms-content">
          <template v-if="!forgotFlag">

            <el-form-item v-if="param.verificationCodeType==='EMAIL'" style="margin-top: 0px"
                          class="item"
                          prop="account">
              <div class="label label-disabled-active">{{ $t('login_account') }}</div>
              <el-input disabled
                        v-model="param.account">
              </el-input>
            </el-form-item>
            <el-form-item v-else  class="item code-item mb_40 "
                            prop="code">
                             <div class="label label-disabled-active" >{{ $t('login.phone') }}</div> 
                  <el-input class="phone-input right-btn-item" @keyup.enter.native="submitForm()"
                            ref="phoneInput"
                            disabled
                            :placeholder="$t('login.phone')"
                            v-model="param.receiverNumber"
                            >
                    <template slot="prepend">
                      <el-select disabled class="forget-phone-prepend" :class="{'zh-width':$i18n.locale==='zh'}" v-model="regionPhone" slot="prepend" placeholder="请选择">
                        <el-option :label="$t('login.china')" value="+86"></el-option>
                        <el-option :label="$t('login.HongKong')" value="+852"></el-option>
                        <el-option :label="$t('login.Macau')" value="+853"></el-option>
                      </el-select>
                    </template>
                  </el-input>
              </el-form-item>

               <el-form-item class="item code-item"
                            prop="code">
                <div :class="codeFocus ? 'label label-active' : 'label'" @click="() => { $refs.codeInput.focus() }">{{ $t('login_verification_Code') }}</div>
                <el-input @keyup.enter.native="submitForm()"
                          ref="codeInput"
                          v-model="param.verificationCode"
                          :class="['right-btn-item', codeBtn ? 'code_disabled' : '']"
                          @focus="codeFocus = true">
                  <template slot="append">
                    <el-button :disabled="codeBtn"
                               class="login-btn"
                               :loading="codeLoading"
                               @click="getCode()"
                               type="primary">
                      {{getCodeSecond > 0 ? `${getCodeSecond} s` : $t('login_btn_getCode') }}
                    </el-button>
                  </template>
                  </el-input>
                </el-form-item>
            </template>
            <template v-if="forgotFlag">
                <el-form-item style="margin-top: 0px"
                        class="item"
                        prop="account">
                  <div class="label label-disabled-active">{{ $t('login_account') }}</div>
                  <el-input disabled
                            v-model="param.account">
                  </el-input>
              </el-form-item>
              <el-form-item class="item"
                            prop="newPassword" style="margin-bottom: 0.27rem;">
                <div :class="newPwdFocus ? 'label label-active' : 'label'" @click="() => { $refs.newPassword.focus() }">{{ $t('login_new_passWorld') }}</div>
                <el-input show-password
                          ref="newPassword"
                          @blur="newPasswordChange"
                          v-model="param.newPassword"
                          onpaste="return false"
                          @focus="newPwdFocus = true">
                  <template slot="append">
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="item"
                            prop="reNewPassword" style="margin-bottom: 0.27rem;">
                <div :class="reNewPwdFocus ? 'label label-active' : 'label'" @click="() => { $refs.reNewPassword.focus() }">{{ $t('login_renew_passWorld') }}</div>
                <el-input show-password
                          ref="reNewPassword"
                          @keyup.enter.native="submitForm()"
                          v-model="param.reNewPassword"
                          onpaste="return false"
                          @focus="reNewPwdFocus = true">
                  <template slot="append">
                  </template>
                </el-input>
              </el-form-item>
            </template>
            <div class="footer-login">
              <el-button :loading="loginLoading"
                         class="login-btn login-item"
                         type="primary"
                         @click="submitForm()">
                {{$t('login_btn_confirm')}}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
  import SvgIcon from "@/components/svgIcon";
import API from '@/api'
import VBottom from '@/components/common/Bottom.vue'
import { encryptForGCM, UserInput } from '@/utils/index'
import LoginTop from '@/components/common/LoginTop'
import PwdNotice from '@/components/common/PwdNotice.vue'
const validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('Enter new password！请再次输入密码！'))
    } else if (value !== this.param.newPassword) {
        callback(new Error('Two inconsistent passwords！两次输入密码不一致！'))
    } else {
        callback()
    }
}

const regionDict = {"+86":"CN","+852":"HK","+853":"MO"};
export default {
    data() {
        return {
            codeLoading: false,
            loginLoading: false,
            codeBtn:false,
            codeFocus:false,
            getCodeSecond:0,
            loginText: '',
            regionPhone:"",
            forgotFlag:"",
            param: {
                verificationCodeType:"EMAIL",
                receiverNumber:"",
                account: '',
                newPassword: '',
                reNewPassword: '',
                verificationCode:""
                /*code: ''*/
            },
            timer: '',
          newPwdFocus: false,
          reNewPwdFocus: false,
          aesKey: '',
          pwdMsg: false,
          tabsShow:false,
          getCodeSecond:0,
          tabs:[
                {
                  code:"SMS",
                  icon:"Mobile",
                  name:"login.SMS"
                },
                {
                  code:"EMAIL",
                  icon:"Email",
                  name:"login.Email"
                }
              ],
        }
    },
    computed: {
        rules() {
            const rules = {
                account: [{ required: true, message: this.$t('FORM_VALIDATE_ACCOUNT'), trigger: 'blur' }],
                newPassword: [
                    { required: true, message: this.$t('FORM_VALIDATE_PASSWORLD'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg2,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_03')
                    },
                    { min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur' }
                ],
                reNewPassword: [
                    {
                        pattern: UserInput.reg2,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_03')
                    },
                    { min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur' },
                    { validator: this.validatePass2, trigger: 'blur' }
                ]
            }
            return rules
        }
    },
    methods: {
      handleTabClick(){
        this.param.verificationCode =''
      },
      checkAccount() {
          if (this.param.account) {
          API.common.checkAccount({ param: this.param.account }).then((res) => {
              if (res.code === '1') {
              this.pwdMsg = res.data.oldPwdFlag;
              if(res.data.phone){
                this.tabsShow = true;
                  this.param.verificationCodeType = "SMS";
                  this.handlePhoneNumber(res.data.phone);
              }else{
                this.getCode()
              }
              }
          })
          }
      },
      handlePhoneNumber(phone){
          if(!phone) return;
          if(phone.indexOf("+86")>-1){
          this.param.receiverNumber = phone.substring(3);
          this.regionPhone = phone.substring(0,3);
          }else{
          this.param.receiverNumber = phone.substring(4);
          this.regionPhone = phone.substring(0,4);
          }
      },
      getAesKey() {
          API.common.secretKey().then(res => {
              if (res.code == '1') {
                  this.aesKey = res.data
                  localStorage.setItem('aesKey', res.data)
              }
          })
      },
      getCode() {
        this.codeLoading = true
        const params = {
          verificationCodeType:this.param.verificationCodeType,
          receiverNumber:this.regionPhone+ this.param.receiverNumber,
          verificationType:"RESET_PASSWORD",
          smsLang:this.$i18n.locale,
          region: regionDict[this.regionPhone],
          account: this.param.account
        };
        API.common
                .verificationLogin(params)
                .then(res => {
                  if (res.code == '1') {
                    this.codeLoading = false
                   const _verificationCodeType= this.param.verificationCodeType
                    this.codeBtn = true
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: _verificationCodeType=='SMS'? this.$t('verification_code_send_success4SMS') : this.$t('verification_code_send_success4Email'),
                      type: 'success'
                    })
                    // let times = 60
                    const that = this
                    that.getCodeSecond = 60
                    that.getCodeSecond = 60
                    that.timer = setInterval(() => {
                      const times =that.getCodeSecond;
                      if (times != 0) {
                        that.getCodeSecond = times-1
                      } else {
                        clearInterval(that.timer)
                        that.codeBtn = false
                        that.getCodeSecond = 0
                      }
                    }, 1000)
                  } else {
                    this.$message.error(this.$t(res.code))
                  }
                })
                .catch(err => {
                  this.$message.error(this.$t('msg_error'))
                })
                .finally(() => {
                  this.codeLoading = false
                })
      },
      validationCode(){
        if(!this.param.verificationCode){
           this.loginLoading = false
          this.$message.error(this.$t("login.emptyVerification"));
          return;
        }
        const params = {account:this.param.account,
          verificationCodeType:this.param.verificationCodeType,
          receiverNumber:this.regionPhone+ this.param.receiverNumber,
          verificationType:'RESET_PASSWORD',
          verificationCode:this.param.verificationCode
          };
        API.common.validationCode(params).then(res=>{
            this.loginLoading = false
            if(res.code =="1"){
              this.forgotFlag ='validated';
            }else{
              this.$message.error(this.$t(res.code))
            }
        })
      },
        validatePass2(rule, value, callback){
            if (value === '') {
                callback(new Error(this.$t('FORM_VALIDATE_RENEW_PASSWORD')))
            } else if (value !== this.param.newPassword) {
                callback(new Error(this.$t('FORM_VALIDATE_NEW_PASSWORD_INCONSISTEN')))
            } else {
                callback()
            }
        },
        newPasswordChange() {
            if (this.param.newPassword) {
                this.$refs.login.validateField('newPassword')
                this.$refs.login.validateField('reNewPassword')
            }
        },
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    this.loginLoading = true
                    const aesNewPswd = encryptForGCM(this.param.newPassword, localStorage.getItem('aesKey'))
                    let params = {
                        userAccount: this.param.account,
                        newPswd: aesNewPswd,
                    }
                    if(!this.forgotFlag){this.validationCode();return;}

                    API.common
                        .forgetUpdatePassword(params)
                        .then(res => {
                            if (res.code == '1') {
                                this.loginLoading = false
                                this.$message.success(this.$t('msg_success'))
                                this.$router.push('/login')
                                localStorage.removeItem('please_change_password')
                            } else if (res.code == 'CLIENT_USER_010') {
                                this.$message({
                                type: 'error',
                                dangerouslyUseHTMLString: true,
                                message: this.$t('CLIENT_USER_010')
                                })
                            } else {
                                this.$message.error(this.$t(res.code))
                            }
                        })
                        .catch(err => {})
                        .finally(() => {
                            this.loginLoading = false
                        })
                }
            })
        }
    },
    mounted() {
        this.loginText = 'login_btn_getCode'
        this.param.account = this.$route.query.account
        this.param.code = this.$route.query.code
        if (!localStorage.getItem('aesKey')) {
            this.getAesKey()
        }
        this.checkAccount()
    },
    components: {
      VBottom,
      LoginTop,
      PwdNotice,
      SvgIcon
    },
}
</script>

<style scoped>
.login-btn {
    height: 100%;
    box-sizing: border-box;
    background-color: #3879eb;
    font-size: 21px !important;
  }

.font-light{
    color: #00338d;
    font-size: 18px;
    vertical-align: middle;
    margin-bottom: 25px;
  }
  
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/loginbg.png") center center/100% 100% no-repeat fixed;
}

.login-top {
    position: relative;
    width: 100%;
    height: 100%;
}

.content-part{
  height: calc(100% - 193px);
  position: relative;
}
  .imglogo img {
    width: 1036px;
  }

.ms-title {
  color: #00338d;
  font-size: 42px;
  line-height: 66px;
  font-family: 'KPMG Light', 'KPMG';
  /* margin-bottom: 30px; */
}

.ms-login {
    position: absolute;
    right: 10%;
    top: 10%;
    width: 570px;
    height: 591px;
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
    border-radius: 8px;
    padding: 45px;
}

.ms-content .item {
  margin-bottom: 25px;
}

.ms-content .item .error {
    font-size: 15px;
}

.login-tips {
    display: block;
    margin-top: 24px;
    font-weight: 400;
    font-style: normal;
    font-size: 21px;
    color: #005eb8;
    text-align: center;
}

.footer-login {
    margin: 0 auto;
    width: 480px;
    height: 60px;
    font-size: 21px;
  padding-top: 20px;
}

.login-item {
    height: 60px;
    border: none;
    border-radius: 8px;
    font-size: 21px;
    background-color: #005eb8;
}

.login-item:hover {
    background-color: #0091da;
}

.passWorldTip {
    width: 43%;
    position: absolute;
    right: calc(10% + 660px);
    font-size: 18px;
    color: #fff;
    line-height: 36px;
    border-radius: 15px;
    padding: 20px 40px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    height: 591px;
    top:10%;
    backdrop-filter: blur(10px);
}

.ms-content .title {
    font-weight: 400;
    font-style: normal;
    font-size: 21px;
    color: #005eb8;
}

.tips-icon{
    width: 40px;
    height: 40px;
    margin-right: 20px;
}
 ::v-deep .el-input__inner {
    font-size: 16PX !important;
  }

  .el-input-group--prepend .forget-phone-prepend {
        background: #fff;
        width: 220px;
      }
      .zh-width{
         width: 150px !important;
      }
    .phone-input .el-input__inner {
        border-left: none !important;
        border-radius: 0 !important; 
    }
    .phone-input .forget-phone-prepend {
      border-radius: 12px 0 0 12px !important; 
    }
     .cust-tabs{
      margin-bottom: 30px;
      height: 50px;
      border:none !important;
      box-shadow:none !important;
      
    }
  .cust-tabs .el-tabs__content{
      display: none;
    }
  ::v-deep .cust-tabs .el-tabs__header{
      height:56px;
      padding: 0 10px !important;
      border: 1px solid #E4E7ED !important;
      border-radius: 6px;
    }
   ::v-deep .cust-tabs .el-tabs__nav-wrap{
      width:100%;
      line-height: 56px;
    }
     ::v-deep .el-tabs__nav{
      width: 100%;
      line-height: 56px;
    }
   ::v-deep .el-tabs__item{
      width:50%;
      text-align: center;
      border:none !important;
      height: 40px;
      padding: 3px 0;
      border-radius: 6px;
     position: relative;
      top: 5px;
      font-weight: 600 !important;
    }
    .cust-tabs .tab-label{
      font-size: 18px;
      display: inline-flex;
      align-items: center;
      position: relative;
       color:rgb(38 47 63) ;
    }
    .way-icon{
      position: relative;
      top: -2px;
      margin-right: 4px;
    }

   ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #F5F7FA !important;
    }
    ::v-deep .cust-tabs .el-tabs__item.is-active{
      border:none;
    }
    ::v-deep .cust-tabs .el-tabs__item.is-active .tab-label{
      color: #005eb8 !important;
    }
     ::v-deep .el-input-group--prepend .phone-prepend {
        background: #fff;
        width: 220px;
        font-size:12PX !important;
       
      }
      .zh-width{
         width: 150px !important;
      }
   ::v-deep .el-input-group--prepend .el-select .el-input.is-focus .el-input__inner{
        border-color: #e3e4e6 !important;
        border-right-color: transparent;
    }
   ::v-deep .el-input-group--prepend .el-select .el-input:hover .el-input__inner{
        border-color: #e3e4e6 ;
        border-top:1px solid #e3e4e6;
        border-bottom:1px solid #e3e4e6;
        border-right:0;

    }
   ::v-deep .phone-input .el-input__inner {
        border-left: none !important;
        border-radius: 0 !important; 
    }
   ::v-deep .phone-input .phone-prepend {
      border-radius: 12px 0 0 12px !important; 
    }
</style>


